import { skipToken, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { TeamsApi } from '@/lib/api/teams/team';
import type {
  ResourceFilterStatus,
  ResourceStatus,
  TeamWithIncludedResponse,
} from '@/lib/api/types/teams';
import { teamsQueryKeys } from '@/lib/query-keys/teams';

export const getTeamQueryOptions = ({
  teamId,
  resourceStatus,
}: {
  teamId: number;
  resourceStatus?: ResourceFilterStatus;
}) => {
  return {
    queryKey: teamsQueryKeys.team({ teamId, resourceStatus }),
    queryFn: () => TeamsApi.getTeam(teamId, resourceStatus),
    enabled: !!teamId,
    staleTime: 60 * 60 * 1000,
  };
};

export const useSuspenseGetTeamQuery = ({
  teamId,
  resourceStatus,
}: {
  teamId: number;
  resourceStatus?: ResourceFilterStatus;
}) => {
  return useSuspenseQuery<TeamWithIncludedResponse>({
    ...getTeamQueryOptions({
      teamId,
      resourceStatus,
    }),
  });
};

export const useGetTeamQuery = ({
  teamId,
  resourceStatus,
}: {
  teamId?: number | null;
  resourceStatus?: ResourceStatus;
}) => {
  return useQuery({
    queryKey: teamsQueryKeys.team({ teamId, resourceStatus }),
    queryFn: teamId ? () => TeamsApi.getTeam(teamId, resourceStatus) : skipToken,
  });
};
